import React, { useState } from 'react';
import { Share2, X } from 'lucide-react';

const ShareButton = ({ title = 'Los Legendarios', text = 'Descubre la nueva película de animación Los Legendarios', className = '' }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [copied, setCopied] = useState(false);

  const shareUrl = typeof window !== 'undefined' ? window.location.href : '';

  const shareLinks = [
    {
      name: 'Instagram',
      icon: () => (
        <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
        </svg>
      ),
      action: () => {
        // Instagram doesn't have a direct share URL, copy link for stories
        navigator.clipboard.writeText(shareUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      },
      color: 'hover:bg-gradient-to-r hover:from-[#833ab4]/20 hover:via-[#fd1d1d]/20 hover:to-[#fcb045]/20 hover:text-[#fd1d1d]'
    },
    {
      name: 'TikTok',
      icon: () => (
        <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
          <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
        </svg>
      ),
      action: () => {
        navigator.clipboard.writeText(shareUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      },
      color: 'hover:bg-[#000]/20 hover:text-white'
    },
    {
      name: 'X',
      icon: () => (
        <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
        </svg>
      ),
      url: `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(shareUrl)}`,
      color: 'hover:bg-[#000]/20 hover:text-white'
    },
    {
      name: 'Facebook',
      icon: () => (
        <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      ),
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
      color: 'hover:bg-[#1877f2]/20 hover:text-[#1877f2]'
    },
    {
      name: 'Email',
      icon: () => (
        <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="4" width="20" height="16" rx="2"/>
          <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
        </svg>
      ),
      url: `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(`${text}\n\n${shareUrl}`)}`,
      color: 'hover:bg-[#f5f5dc]/20 hover:text-[#f5f5dc]'
    }
  ];

  const handleShare = (link) => {
    if (link.url) {
      window.open(link.url, '_blank', 'width=600,height=400');
    } else if (link.action) {
      link.action();
    }
    setShowMenu(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setShowMenu(!showMenu)}
        className={`flex items-center gap-2 text-[#f5f5dc]/60 hover:text-[#f5f5dc] transition-colors ${className}`}
        data-testid="share-button"
      >
        <span className="text-sm hidden sm:inline">Compartir</span>
        <Share2 className="w-4 h-4" />
      </button>

      {/* Share Menu Popup */}
      {showMenu && (
        <>
          {/* Backdrop */}
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => setShowMenu(false)}
          />
          
          {/* Menu */}
          <div 
            className="absolute right-0 top-full mt-2 w-56 bg-[#0a1118] border border-[#50c878]/40 rounded-xl shadow-2xl z-50 overflow-hidden animate-fade-in"
            data-testid="share-menu"
          >
            <div className="flex items-center justify-between p-3 border-b border-[#50c878]/20">
              <span className="text-[#f5f5dc] font-medium text-sm">Compartir en</span>
              <button
                onClick={() => setShowMenu(false)}
                className="w-6 h-6 rounded-full hover:bg-[#f5f5dc]/10 flex items-center justify-center text-[#f5f5dc]/60 hover:text-[#f5f5dc]"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
            
            <div className="p-2">
              {shareLinks.map((link) => (
                <button
                  key={link.name}
                  onClick={() => handleShare(link)}
                  className={`flex items-center gap-3 w-full p-3 rounded-lg text-[#f5f5dc]/70 transition-colors ${link.color}`}
                  data-testid={`share-${link.name.toLowerCase()}`}
                >
                  <link.icon />
                  <span className="text-sm">{link.name}</span>
                  {(link.name === 'Instagram' || link.name === 'TikTok') && copied && (
                    <span className="text-xs text-green-400 ml-auto">¡Copiado!</span>
                  )}
                </button>
              ))}
            </div>
            
            <div className="px-3 pb-3">
              <p className="text-[#f5f5dc]/40 text-xs text-center">
                Instagram y TikTok: se copia el enlace
              </p>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ShareButton;
